import { Component } from "@angular/core";

import { Tab, NavParams, MenuController, NavController } from "ionic-angular";

import { SettlementAllPage } from "../settlementall/settlementall";
import { SettlementsPendingPage } from "../settlementspending/settlementspending";
import { SettlementConfirmedPage } from "../settlementconfirmed/settlementconfirmed";
import { SettlementCancelledPage } from "../settlementcancelled/settlementcancelled";

@Component({
  selector: "tabs-settlement",
  templateUrl: "tabs-settlement.html"
})
export class TabSettlement {
  // set the root pages for each tab
  all: any = SettlementAllPage;
  pending: any = SettlementsPendingPage;
  confirmed: any = SettlementConfirmedPage;
  cancelled: any = SettlementCancelledPage;

  mySelectedIndex: any = 0;

  constructor(
    navParams: NavParams,
    public menu: MenuController,
    public navCtrl: NavController
  ) {}

  ionViewDidLoad() {
    this.menu.enable(true);
  }

  tabChanged(tab: Tab) {}
}



// WEBPACK FOOTER //
// ./src/pages/settlement/tabs/tab-settlement.ts